<template>
    <div id="s-monthSelector">
        <b-row class="justify-content-center">
                <span class="btnContainer" v-if="selectStatus">
                    <b-button :disabled="disable" :class="selectItemText == '' ? 'btnShow btnShowStateOff' : 'btnShow btnShowStateOn'" @click="$bvModal.show(name)">{{title}} {{month[value].name}}</b-button>
                </span>
                <span class="btnContainer" v-else>
                    <b-button :disabled="disable" class="btnShow btnShowStateStd" @click="$bvModal.show(name)">{{title}} {{month[value].name}} </b-button>
                </span>
        </b-row>
    
            <b-modal :body-bg-variant="getTheme.light" :header-bg-variant="getTheme.dark" :header-text-variant="getTheme.light" :id="name" :title="title" hide-footer>
                
                <!--<b-row class="addLicContainer">
                    <b-form-input class="txtLeft" id="search" name="search" type="text" :placeholder="$t('p_Recherche')" v-model="txtRecherche"></b-form-input>
                    <b-button type="button" class="btnLeft" @click="txtRecherche = ''">{{$t('g_Efface')}}</b-button>
                </b-row>-->

                <!--CONTENU-->
                <div class="scroll borderMain">
                    
                    <b-list-group style="margin-top: 5px">
                            <span v-for="(item, index) in month" :key="item.index">
                                <b-list-group-item v-if="index > 0" :class="index == displayValue ? 'cursorPoint btnStylSelected' : 'cursorPoint btnStyle'" @click="handleInput(index, item.name), displayValue = index">
                                    <span>{{item.name}}</span>
                                </b-list-group-item>
                            </span>
                    </b-list-group>

                </div>
            </b-modal>
        </div>
    
</template>

<script>
import {mapGetters} from 'vuex'


export default{
    name: 's-monthSelector',
    props: ['value', 'disable', 'name','selectStatus', 'title'],
    data() {
        return {
            txtRecherche: '',
            selectItemText: '',
            month: [
                {name: 'null'},
                {name: this.$t('datM_Janvier')},
                {name: this.$t('datM_Fevrier')},
                {name: this.$t('datM_Mars')},
                {name: this.$t('datM_Avril')},
                {name: this.$t('datM_Mai')},
                {name: this.$t('datM_Juin')},
                {name: this.$t('datM_Juillet')},
                {name: this.$t('datM_Aout')},
                {name: this.$t('datM_Septembre')},
                {name: this.$t('datM_Octobre')},
                {name: this.$t('datM_Novembre')},
                {name: this.$t('datM_Decembre')},
            ]
        }
    },
    methods: {
        handleInput(valeur, itemText) {
            console.log(valeur + ' : ' + itemText)
            this.selectItemText = itemText
            this.$emit('update:returnValue', valeur)
            this.$bvModal.hide(this.name)
        },
        //getSelectedText(itemNumber){
        //        var i;
        //        for (i = 0; i < this.content.length; i++) {
        //            if (this.content[i].id == itemNumber)
        //                {return this.content[i][this.showField]}
        //        }
        //    return '---'
        //}
    },
    computed: {
        ...mapGetters(['getTheme', 'getLanguage']),
        status() {
            return this.value
        },
        displayValue: {
            get: function() {
                let sendValue = this.value
                return sendValue
                },
            set: function(modifiedValue) {
                let newValue = modifiedValue
                this.$emit('input', newValue)
            }
        }

    },
    watch: {
        getLanguage: function() {
                this.month[1].name = this.$t('datM_Janvier')
                this.month[2].name = this.$t('datM_Fevrier')
                this.month[3].name = this.$t('datM_Mars')
                this.month[4].name = this.$t('datM_Avril')
                this.month[5].name = this.$t('datM_Mai')
                this.month[6].name = this.$t('datM_Juin')
                this.month[7].name = this.$t('datM_Juillet')
                this.month[8].name = this.$t('datM_Aout')
                this.month[9].name = this.$t('datM_Septembre')
                this.month[10].name = this.$t('datM_Octobre')
                this.month[11].name = this.$t('datM_Novembre')
                this.month[12].name = this.$t('datM_Decembre')
        },
        //selectedItems: function() {
        //    //console.log(this.baseZero)
        //    if (this.noNone)
        //    {
        //        console.log(this.getSelectedText(this.selectedItems))
        //        this.selectItemText = ' : ' + this.getSelectedText(this.selectedItems)//' : ' + this.getSelectedText(this.selectedItems)
        //    }
        //    else
        //        {
        //        if (this.baseZero)
        //        {
        //            //console.log('1')
        //            if (this.selectedItems < 0)
        //            {this.selectItemText = ''}
        //            else
        //            {this.selectItemText = ' : ' + this.getSelectedText(this.selectedItems)}
        //        }
        //        else
        //        {
        //            //console.log('2')
        //            if (this.selectedItems <= 0)
        //            {this.selectItemText = ''}
        //            else
        //            {this.selectItemText = ' : ' + this.getSelectedText(this.selectedItems)}
        //        }
        //    }
        //}
    //    selectedItems(){
    //        if (this.selectedItems == -1 || this.selectedItems == 0)
    //        {return ''}
    //        else
    //        {return 'allo'}
    //     }
    }    
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/components/comboSelector.scss';
</style>